export default __webpack_public_path__ + "static/media/tour-3.be0128f4.jpeg";